import React from 'react';
import { useState } from "react";
import { useDrop } from 'react-dnd';

export function DropZone({ currentImageIndex, imageList, moveImageToNewIndex, children }) {
  const [currentIndex,setCurrentIndex] = useState(-1)
  const [{ isOver }, drop] = useDrop(() => ({
    accept: 'PHOTO',
    drop: (item) => {
      const { id, index } = item;
      console.log('drop - '+id+' - '+currentImageIndex);
      setCurrentIndex(index)
      moveImageToNewIndex(id, currentImageIndex);

    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }));

  return (
    <div ref={drop} style={{ backgroundColor: isOver ? '#F0F0F0' : 'transparent' }}>
      <div>
        {children}
      </div>
    </div>
  );
}

export default DropZone;
